export enum PickingListType {
    Transhipment = 1,
    Delivery = 2
}